<template>
  <div class="side-nav-layout">
    <SideNavBar />
    <div class="top-bar-layout">
      <HomeTopBar />
      <simplebar class="layout-contents" data-simplebar-auto-hide="true">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </simplebar>
    </div>
  </div>
</template>

<script>
import HomeTopBar from "@/components/home/views/HomeTopBar";
import SideNavBar from "@/components/home/views/SideNavBar";

export default {
  name: "home",
  components: {
    HomeTopBar,
    SideNavBar,
  },
  mounted() {
    // show freshcaht icon
    if (window.fcWidget) window.fcWidget.show();
  },
};
</script>

<style lang="scss">
.side-nav-layout {
  height: 100%;
  display: grid;
  grid-template-columns: 270px 1fr;

  .top-bar-layout {
    height: 100%;
    overflow: hidden;
  }

  .layout-contents {
    position: relative;
  }
}
</style>
